export default __webpack_public_path__ + "static/media/52.b39c9b58.jpg";